import api, { V1 } from './axios';

export interface ArticleSummary {
  slug: string;
  title: string;
  summary?: string;
  published_date?: string;
  updated_at?: string;
  tags?: string[];
}

export interface ArticleDetail extends ArticleSummary {
  content: string;
}

export interface PaginatedArticles {
  count: number;
  page: number;
  page_size: number;
  results: ArticleSummary[];
}

export const articlesApi = {
  getAll: (page = 1, pageSize = 10) =>
    api.get<PaginatedArticles>(`${V1}config/articles/`, {
      params: { page, page_size: pageSize },
    }),

  getBySlug: (slug: string) =>
    api.get<{ article: ArticleDetail }>(`${V1}config/articles/${encodeURIComponent(slug)}/`),
};
